// Client "Billing" panel, opened from the Billing button on My Invoices (and
// from the "update your card" email via ?billing=open). One place for
// everything a client configures about how they pay: card / bank on file,
// automatic billing, and who receives invoices.
import React from 'react';

import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import InvoiceRecipientsCard from '@src/components/billing/InvoiceRecipientsCard';
import PaymentMethodOnFileCard from '@src/components/billing/PaymentMethodOnFileCard';

export default function BillingSettingsDrawer({ open, onClose, profiles }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: '100%', sm: 560 } } }}
    >
      <Box sx={{ p: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 3 }}>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 700 }}>
              Billing
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              How you pay and who receives your invoices.
            </Typography>
          </Box>
          <IconButton onClick={onClose} aria-label="Close billing">
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack spacing={3}>
          <PaymentMethodOnFileCard profiles={profiles} />
          <InvoiceRecipientsCard />
        </Stack>
      </Box>
    </Drawer>
  );
}
